import { useMutation } from "@tanstack/react-query";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import CloudAppAPI from "../../api/CloudAppAPI";
import { newToastEvent } from "../../../utils/ToastUtil";

const useCopyCloudApp = () => {
  const copyCloudApp = useMutation({
    mutationFn: async ({
      fromCloudID,
      toCloudID,
      cloudAppID,
    }: {
      [key: string]: string;
    }) => {
      return CloudAppAPI.copyCloudAppToAnotherCloud(
        fromCloudID,
        toCloudID,
        cloudAppID
      );
    },
    onSuccess: () => {
      newToastEvent("success", `Successfully copied app over.`);
    },
    onError: (err: any) => {
      newToastEvent("error", getErrorMessage(err));
    },
  });

  return {
    copyCloudApp: copyCloudApp.mutate,
    copying: copyCloudApp.isPending,
    error: copyCloudApp.isError,
  };
};

export default useCopyCloudApp;
